// src/Layout.js
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import "../styles.css";

function Layout() {
    const location = useLocation();

    // Determine the current tab based on pathname
    let currentTab = "";
    if (location.pathname.startsWith("/home")) {
        currentTab = "home";
    } else if (location.pathname.startsWith("/calculator")) {
        currentTab = "calculator";
    } else if (location.pathname.startsWith("/report")) {
        currentTab = "report";
    }

    return (
        <>
            {/* TopBar is rendered outside of the content wrapper */}
            <TopBar currentTab={currentTab} />
            <div className="wrapper">
                <Outlet />
            </div>
        </>
    );
}

export default Layout;
